import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator,MatTableDataSource,MatDialog,MatDialogRef,MAT_DIALOG_DATA,MatSortModule,MatSort,MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { NgxSpinnerService } from 'ngx-spinner';
export interface Condiciones {
  criterio: string;
  condicion: string;
  valor: string;
}

@Component({
  selector: 'app-create-ciclo',
  templateUrl: './create-ciclo.component.html',
  styleUrls: ['./create-ciclo.component.scss']
})
export class CreateCicloComponent implements OnInit {

  cicloColumns:any = ['NOMBRE','DIAN','MENSAJE','ACCION'];
  dataSource = new MatTableDataSource<any>([]);

  constructor(@Inject(MAT_DIALOG_DATA) public data, 
    private tabController: ComponentTabController, 
    private spinner: NgxSpinnerService,
    private gateway: GatewayService, 
    public snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<CreateCicloComponent>,
  private localSave: LocalSaveService) { }

  ngOnInit() {
    this.getCiclo();
  }

  grupoVal = new FormGroup({
    dian1         :   new FormControl('', [Validators.compose([Validators.required, Validators.min(1),Validators.pattern('[0-9]+')])]),
    nombre       :    new FormControl('', [Validators.compose([Validators.required, Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")])]),
    mensaje       :   new FormControl('', [Validators.compose([Validators.required])]),
  });

  getCiclo(){
    this.gateway.get('obtenerciclo',{IDCAMPANA:this.localSave.get('campana')}).then((result:any) =>{
      const auxresult:any = result.rows;
      let data = [];
      // console.log("CICLO BEGIN");
      // console.log(auxresult);
      // console.log("CICLO END");
      auxresult.map((ciclo)=>{
        data.push({NOMBRE:ciclo.nombre,DIAN:ciclo.dian,MENSAJE:ciclo.mensaje});
      });
      this.dataSource = new MatTableDataSource(data);
    }
    ).catch(function(e) {
    });

  }

  onNoClick() {
    this.localSave.delete('campana');
    this.dialogRef.close();
  }

  addCiclo(){
    let data = this.dataSource.data;
    const cic = {NOMBRE:this.grupoVal.controls.nombre.value,DIAN:this.grupoVal.controls.dian1.value, MENSAJE:this.grupoVal.controls.mensaje.value};

    // console.log(data)
    // if (data.find(element => { return cic.NOMBRE == element.NOMBRE && cic.DIAN == element.DIAN && cic.MENSAJE == element.MENSAJE})) {
    if (data.find(element => { return cic.NOMBRE == element.NOMBRE})) {
      this.snackbar.open('Ciclo ya existente', 'Cerrar', {duration: 3000,});
      this.grupoVal.controls.nombre.setValue('');
      return;
    } else {
      this.grupoVal.controls.nombre.setValue('');
      this.grupoVal.controls.dian1.setValue('');
      this.grupoVal.controls.mensaje.setValue('');
      data.push(cic);
      this.dataSource = new MatTableDataSource(data);
      
    }

    
    this.dataSource = new MatTableDataSource(data);
  }

  save(){
    this.spinner.show();
    let CICLO = {
      DIAN       :  '',
      NOMBRE     :  '',
      MENSAJE    :  '',
      IDCAMPANA  :  this.localSave.get('campana')
    };

    let data     = this.dataSource.data;
    const sendinfo = [];
    data.map((ciclo)=>{
      CICLO.DIAN        =  ciclo.DIAN;
      CICLO.NOMBRE      =  ciclo.NOMBRE;
      CICLO.MENSAJE     =  ciclo.MENSAJE; 
      sendinfo.push(JSON.parse(JSON.stringify(CICLO)));
    });
    this.gateway.save('cleanciclo',{IDCAMPANA:this.data.idcampana}).then((result) =>{
      this.fnsendinfo(sendinfo,0);
    }
    ).catch(function(e) {
    });

  }

  removeciclo(ciclo){
    const data = this.dataSource.data;
    let index = data.map((c)=>{return JSON.stringify(c)}).indexOf(JSON.stringify(ciclo));
    if(index != -1){
      data.splice(index,1);
    }
    this.dataSource = new MatTableDataSource(data);
  }

  fnsendinfo(ciclo,index){
    // console.log(ciclo);
    if(index < ciclo.length-1){
      this.gateway.save('createciclo',ciclo[index]).then((result) =>{
        this.fnsendinfo(ciclo,++index);
      }
      ).catch(function(e) {
      });
    }else{
      this.gateway.save('createciclo',ciclo[index]).then((result) =>{
          //this.dialogRef.close();
          this.spinner.hide();
          this.tabController.index = 4;
        // if (this.data.idcampana) { 
        // }
      }
      ).catch(function(e) {
      });
    }
  }

  getError(type){
    if(type == 1){
      if(this.grupoVal.controls.dian1.hasError('required')){
        return 'Debes ingresar una cantidad de días';
      }
    }
    if(type == 2){
      if(this.grupoVal.controls.nombre.hasError('required')){
        return 'Debes ingresar el nombre del ciclo';
      }
    }
    if(type == 3){
      if(this.grupoVal.controls.mensaje.hasError('required')){
        return 'Debes ingresar el mensaje del ciclo';
      }
    }
  }

}
